export const LOGINURL = `//bar.xkw.com/login?service=${encodeURIComponent(window.location.href)}`;
export const LOGINOUTURL = `//bar.xkw.com/logout?service=${encodeURI("https://bar.xkw.com/")}`;
const prefix = "api/v1";
export default {
  tag: `${prefix}/tags/all`,
  color: `${prefix}/tags/color`,
  elements: `${prefix}/elements`,
  backgrounds: `${prefix}/backgrounds`,
  textStyles: `${prefix}/text/styles`,
  // cover的文字样式
  textStyle: `${prefix}/text/style`,
  picSizes: `${prefix}/sizes`,
  portraits: `${prefix}/portraits`,
  virtualPortraits: `${prefix}/virtual-portraits`,
  batchUploadVirtualPortraits: `${prefix}/virtual-portraits/batch-upload`,
  sizesbytype: `${prefix}/sizesbytype`,
  schemes: `${prefix}/schemes`,
  scheme: `${prefix}/scheme`,
  compress: `${prefix}/compress`,
  uploadImage: `${prefix}/upload-image`,
  textCensor: `${prefix}/textcheck/textCensor`,
  auth: {
    userInfo: `${prefix}/user/info`,
  },
  generateCanvas: `${prefix}/canvas/generate`,
  sizeInfo: `${prefix}/size/info`,
  aiGenText: `${prefix}/ai/text`,
  hotWords: `${prefix}/ai/hotwords`,
  materials: "/vector/banners/test-vector",
  contentBgs: `${prefix}/poster/contentBgs`,
  logos: `${prefix}/common/logos`,
  // 提交海报长图设计稿
  posterLongScheme: `${prefix}/poster/scheme`,
  // 根据用户id提交海报长图设计稿
  savePosterByUser: `${prefix}/poster/save-by-user`,
  // 海报长图列表
  posterList: `${prefix}/poster/list`,
  // 根据用户id获取海报长图列表
  posterListByUserId: `${prefix}/poster/list-by-user`,
  // 海报长图详情
  posterLongDetail: `${prefix}/poster/detail`,
  // 删除海报
  deletePoster: `${prefix}/poster/delete`,
  // 根据用户id删除海报
  deletePosterByUserId: `${prefix}/poster/delete-by-user`,
  // 根据用户id获取cover设计列表
  userDesigns: `${prefix}/designs-by-user`,
  // 保存cover设计
  saveSchemeByUser: `${prefix}/save-scheme-by-user`,
  // 根据用户id获取banner设计列表
  userBanners: `${prefix}/designs-by-user`,
  // 根据userId和schemeId删除设计图
  //deleteSchemeByUser: `${prefix}/delete-scheme-by-user`,
  // 弹窗生成模块相关接口
  popup: {
    create: `${prefix}/popup/create`,
    // 弹窗列表
    list: `${prefix}/popup/list`,
    // 根据用户id获取弹窗列表
    listByUserId: `${prefix}/popup/list-by-user`,
    // 删除弹窗
    delete: `${prefix}/popup/delete`,
    // 根据用户id删除弹窗
    deleteByUserId: `${prefix}/popup/delete-by-user`,
    // 获取弹窗详情
    detail: `${prefix}/popup/detail`,
    // 更新弹窗
    update: `${prefix}/popup/update`,
  },
  // 生成mj图片
  mjGenImage: `${prefix}/mj/gen-image`,
  // 生成sd图片
  sdGenImage: `${prefix}/sd/gen-image`,
  // 抠图
  removeBackground: `${prefix}/ai/remove-background`,
  // 提交ai生成结果
  saveAiGenerateResult: `${prefix}/ai/generate-result`,
  // 翻译
  translate: `${prefix}/ai/translate`,
  // sd生图
  getSdImages: `${prefix}/ai/get-sd-images`,
  // 获取sd生图类型列表
  getSdTypes: `${prefix}/ai/get-sd-types`,
  // 即梦生图
  jimengGenImage: `${prefix}/ai/jimeng-gen-image`,
  // gpt编辑图片
  gptEditImage: `${prefix}/ai/gpt-edit-image`,
  // 根据userId和schemeId删除设计图
  deleteSchemeByUser: `${prefix}/delete-scheme-by-user`,
  // 上传图片到OSS
  uploadToOSS: `${prefix}/upload-to-oss`,
  // nano-banana编辑图片
  nanoBananaEditImage: `${prefix}/ai/nano-banana-edit-image`,
  // 优化生图提示词
  optimizePrompt: `${prefix}/ai/optimize-prompt`,
  // 添加文字提示词
  addTextPrompt: `${prefix}/ai/jimeng4-image-add-text`,
  // 用大模型去除图片背景（效果不好）
  nanoBananaDelImageBg: `${prefix}/ai/nano-banana-del-image-bg`,
  // 利用特定接口去除图片背景 并上传到OSS
  removeImgBgAndUploadOss: `${prefix}/ai/remove-bg-upload-oss`,
  // 利用即梦4.0结合图片和提示词生成图片
  jimeng4GenerateImage: `${prefix}/ai/jimeng4-generate-image`,
  // 利用 GPT（gpt-image-2-nx）结合图片和提示词生成图片
  gptGenerateImage: `${prefix}/ai/gpt-generate-image`,
  // 图生视频（后端封装）
  videoGenerate: `${prefix}/ai/video-generate`,
  // 扩图（后端封装）
  outpaint: `${prefix}/ai/outpaint`,
  // 涂抹消除（后端封装）
  inpainting: `${prefix}/ai/inpainting`,
  // 局部重绘（后端封装，支持prompt）
  inpaintingEdit: `${prefix}/ai/inpainting-edit`,
  // 智绘小博士：使用次数 +1
  xbsStatisticCount: `${prefix}/xbs/statistic/count`,
};
